import React, { Component } from 'react';
import Footer from '../../components/layout/Footer';

import '../../assets/style/itemStyle/common.scss';
import { marketingEmail } from '../../untils/constant/email';
import HeaderMeta from 'components/headerMeta/HeaderMeta';

export default class Cookies extends Component {
  render() {
    return (
      <>
        <HeaderMeta type="cookies" />
        <div className="public-container cookies-container">
          <p style={{ 'text-align': 'center' }}>
            <h1 style={{ 'text-decoration': 'underline', fontSize: '16px', fontWeight: 700 }}>
              COOKIES POLICY
            </h1>
          </p>
          <p>The technologies we use for automatic information collection may include:</p>
          <ul>
            <li>
              <b>Cookies (or mobile cookies):</b> We may use {'cookies'} to help you personalize
              your online experience. A cookie is a text file that is placed on your hard disk by a
              web page server. Cookies cannot be used to run programs or deliver viruses to your
              computer. Cookies are uniquely assigned to you and can only be read by a web server in
              the domain that issued the cookie to you. The purpose of a cookie is to tell the web
              server that you have returned to a specific page. You can accept or decline cookies.
              Most web browsers automatically accept cookies, but you can usually modify your
              browser setting to decline cookies if you prefer. If you choose to decline cookies,
              you may not be able to fully experience the interactive features of the Services. The
              types of Cookies we may use on our website:
              <ul>
                <li>
                  <b>Necessary cookies.</b> Necessary cookies help make a website usable by enabling
                  basic functions like page navigation and access to secure areas of the website.
                  The website cannot function properly without these cookies.
                </li>
                <li>
                  <b>Preference cookies.</b> Preference cookies enable a website to remember
                  information that changes the way the website behaves or looks, like your preferred
                  language or the region that you are in.
                </li>
                <li>
                  <b>Statistic cookies.</b> Statistic cookies help website owners to understand how
                  visitors interact with websites by collecting and reporting information
                  anonymously.
                </li>
                <li>
                  <b>Marketing cookies.</b> Marketing cookies are used to track visitors across
                  websites. The intention is to display ads that are relevant and engaging for the
                  individual user and thereby more valuable for publishers and third-party
                  advertisers.
                </li>
                <li>
                  <b>Disabling Cookies.</b> You can block cookies by activating the setting on your
                  browser that allows you to refuse the setting of all or some cookies. However, if
                  you use your browser settings to block all cookies (including essential cookies)
                  you may not be able to access all or parts of our website.
                </li>
              </ul>
            </li>

            <li>
              <b>Web Beacons:</b> The Services and our e-mails may contain small electronic files
              known as web beacons (also referred to as clear gifs, pixel tags and single-pixel
              gifs) that permit us, for example, to count users who have visited those pages or
              opened an e-mail and for other related Services statistics.
            </li>
            <li>
              <b>Social Ad Platforms:</b> We may also use Google Analytics, Facebook, Instagram, and
              Twitter’s functionality of re-marketing through their tracking cookies and pixel-based
              retargeting services. This means that if you provided your consent to Google,
              Facebook, Instagram, TikTok, or Twitter (the “Social Ad Platforms”) to be provided
              with personalized commercial offers, you may be served with ads (including
              advertisements of third parties) based on your access to the Services, outside of the
              Services and across the internet. In such event, the Social Ad Platforms, will place
              cookies on your web browser and use such cookies to serve you ads based on past visits
              to our Services.
            </li>
            <li style={{ 'list-style': 'none' }}>
              Please visit the Social Ad Platforms Privacy policy to find out how they use such
              information:
              <ul>
                <li style={{ 'margin-bottom': '8px' }}>
                  Google:
                  <a href="https://policies.google.com/technologies/ads">
                    https://policies.google.com/technologies/ads
                  </a>
                </li>
                <li style={{ 'margin-bottom': '8px' }}>
                  Facebook:
                  <a href="https://www.facebook.com/about/privacy/">
                    https://www.facebook.com/about/privacy/
                  </a>
                </li>
                <li style={{ 'margin-bottom': '8px' }}>
                  Instagram:{' '}
                  <a href="https://help.instagram.com/478880589321969/">
                    https://help.instagram.com/478880589321969/
                  </a>
                </li>
                <li style={{ 'margin-bottom': '8px' }}>
                  Twitter:{' '}
                  <a href="https://business.twitter.com/en/help/ads-policies/other-policy-requirements/policies-for-conversion-tracking-and-tailored-audiences.html">
                    https://business.twitter.com/en/help/ads-policies/other-policy-requirements/policies-for-conversion-tracking-and-tailored-audiences.html
                  </a>
                </li>
                <li style={{ 'margin-bottom': '8px' }}>
                  TikTok:{' '}
                  <a href="https://www.tiktok.com/legal/cookie-policy?lang=en">
                    https://www.tiktok.com/legal/cookie-policy?lang=en
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <b>Mobile Device Identifiers.</b> Mobile device identifiers help Airacer learn more
              about our users’ demographics and internet behaviors. Mobile device identifiers are
              data stored on mobile devices that may track mobile device and data and activities
              occurring on and through it, as well as the applications installed on it. Mobile
              device identifiers enable collection of Personal Information (such as media access
              control, address and location, and tracking data, including without limitation IP
              address, domain server, type of device(s) used to access the Services, web browser(s)
              used to access the Services, referring webpage or other source through which you
              accessed the Services, other statistics and information associated with the
              interaction between your browser or device and the Services).
            </li>
            <li>
              <b>Cross Device Matching. </b>To determine if users have interacted with content
              across multiple devices and to match such devices, we may work with partners who
              analyze device activity data and/or rely on your information (including demographic,
              geographic and interest-based data). To supplement this analysis, we may also provide
              de-identified data to these partners. Based on this data, we may then display targeted
              advertisements across devices that we believe are associated or use this data to
              further analyze usage of Services across devices.
            </li>
          </ul>
          <p>
            You can decide whether or not to accept Cookies through your internet browser’s
            settings. Most browsers have an option for turning off the Cookie feature, which will
            prevent your browser from accepting new Cookies, as well as (depending on your browser
            software) allow you to decide on acceptance of each new Cookie in a variety of ways. You
            may also be able to reject mobile device identifiers by activating the appropriate
            setting on your mobile device. You can also delete all Cookies that are already on your
            computer. Although you are not required to accept Airacer’s Cookies, if you block,
            reject, or delete them, you may have to manually adjust some preferences every time you
            visit a site and some of the Services and functionalities may not work.
          </p>
          <p>
            To explore what Cookie settings are available to you, look in the “preferences” or
            “options” section of your browser’s menu. To find out more information about Cookies,
            including information about how to manage and delete Cookies, please visit{' '}
            <a href="https://www.allaboutcookies.org/">https://www.allaboutcookies.org/.</a>
          </p>
          <p>
            In addition, if you wish not to receive ads from us based on information we obtain from
            use of cookies and pixel tags, please send us an e-mail to {marketingEmail} and we will
            respond within a reasonable time frame and in accordance with applicable laws.
          </p>
        </div>
        <Footer />
      </>
    );
  }
}
